<template>
  <div class="container">
    <Tbheader :tipo="tipo + ' - Serviços'" :novo="novo" :titulo="contentEdit.titulo" :icone="icone" />
    <form class id="feedback-form" @submit="formSubmit" method="post">
      <div class="row">
        <div class="col-8 form-group">
          <label>Título:</label>
          <input
            type="text"
            v-model="contentEdit.titulo"
            name="titulo"
            id="titulo"
            class="form-control required valid"
            value
          />
        </div>
        <div class="col-2 form-group">
          <label>Data:</label>
          <input
            type="date"
            v-model="contentEdit.data"
            name="data"
            id="data"
            class="form-control required valid"
            value
          />
        </div>

        <div class="col-md-2 form-group">
          <label>Ativo:</label>
          <div class="btn-group btn-group-toggle d-flex" data-toggle="buttons">
            <label
              class="btn btn-outline-secondary ls0 nott"
              id="ativo"
              :class="{'active': contentEdit.ativo == true}"
            >
              <input type="radio" name="ativo" id="ativo" @change="fnAtiva() " :value="true" autocomplete="off" class="valid" /> Sim
            </label>
            <label
              class="btn btn-outline-secondary ls0 nott"
              id="inativo"
              :class="{'active': contentEdit.ativo == false}"
            >
              <input type="radio" name="ativo" id="inativo"  @change="fnAtiva()"  :value="false" autocomplete="off" class="valid" /> Não
            </label>
          </div>
        </div>
        <div class="col-md-2 form-group">
          <label>AutoEspecialistas:</label>
          <div class="btn-group btn-group-toggle d-flex" data-toggle="buttons">
            <label
              class="btn btn-outline-secondary ls0 nott"
              id="ativo"
              :class="{ active: contentEdit.autoespecialistas == true }"
              @click="contentEdit.autoespecialistas = true"
            >
              <input
                type="radio"
                name="ativo"
                id="ativo"
                :value="true"
                autocomplete="off"
                class="valid"
              />
              Sim
            </label>
            <label
              class="btn btn-outline-secondary ls0 nott"
              id="inativo"
              :class="{ active: contentEdit.autoespecialistas == false }"
                @click="contentEdit.autoespecialistas = false"
            >
              <input
                type="radio"
                name="ativo"
                id="inativo"
                :value="false"
                autocomplete="off"
                class="valid"
              />
              Não
            </label>
          </div>
        </div>
        <div class="col-md-2 form-group">
          <label>Gape:</label>
          <div class="btn-group btn-group-toggle d-flex" data-toggle="buttons">
            <label
              class="btn btn-outline-secondary ls0 nott"
              id="ativo"
              :class="{ active: contentEdit.gape == true }"
              @click="contentEdit.gape = true"
            >
              <input
                type="radio"
                name="ativo"
                id="ativo"
                :value="true"
                autocomplete="off"
                class="valid"
              />
              Sim
            </label>
            <label
              class="btn btn-outline-secondary ls0 nott"
              id="inativo"
              :class="{ active: contentEdit.gape == false }"
                @click="contentEdit.gape = false"
            >
              <input
                type="radio"
                name="ativo"
                id="inativo"
                :value="false"
                autocomplete="off"
                class="valid"
              />
              Não
            </label>
          </div>
        </div>
        <div class="col-md-2 form-group">
          <label>E-sinistros:</label>
          <div class="btn-group btn-group-toggle d-flex" data-toggle="buttons">
            <label
              class="btn btn-outline-secondary ls0 nott"
              id="ativo"
              :class="{ active: contentEdit.esinistros == true }"
              @click="contentEdit.esinistros = true"
            >
              <input
                type="radio"
                name="ativo"
                id="ativo"
                :value="true"
                autocomplete="off"
                class="valid"
              />
              Sim
            </label>
            <label
              class="btn btn-outline-secondary ls0 nott"
              id="inativo"
              :class="{ active: contentEdit.esinistros == false }"
                @click="contentEdit.esinistros = false"
            >
              <input
                type="radio"
                name="ativo"
                id="inativo"
                :value="false"
                autocomplete="off"
                class="valid"
              />
              Não
            </label>
          </div>
        </div>
        <div class="col-md-2 form-group">
          <label>E-oficinas:</label>
          <div class="btn-group btn-group-toggle d-flex" data-toggle="buttons">
            <label
              class="btn btn-outline-secondary ls0 nott"
              id="ativo"
              :class="{ active: contentEdit.eoficinas == true }"
              @click="contentEdit.eoficinas = true"
            >
              <input
                type="radio"
                name="ativo"
                id="ativo"
                :value="true"
                autocomplete="off"
                class="valid"
              />
              Sim
            </label>
            <label
              class="btn btn-outline-secondary ls0 nott"
              id="inativo"
              :class="{ active: contentEdit.eoficinas == false }"
                @click="contentEdit.eoficinas = false"
            >
              <input
                type="radio"
                name="ativo"
                id="inativo"
                :value="false"
                autocomplete="off"
                class="valid"
              />
              Não
            </label>
          </div>
        </div>

        <div class="col-sm-12"><label>Imagem:</label></div>
        <div class="col-sm-6 text-center">
          <div
            class="areaFoto"
            :class="contentEdit.imagem ? 'ativo' : ''"
            @click="$refs.imagem.click()"
            :style="
              contentEdit.imagem && carregado
                ? 'background:url(' + contentEdit.imagem + ')'
                : 'background:url()'
            "
          >
            <i class="icon-cloud-upload-alt"></i>
            <input
              type="file"
              @change="OnFileSelected"
              id="imagem"
              name="imagem"
              ref="imagem"
              style="display: none"
              class="form-control"
              accept="image/*"
            />
          </div>
          <button
            v-if="contentEdit.imagem && tipo != 'Copiando'"
            class="btn btn-danger"
            @click.prevent="fnRemoveFoto('imagem', 1)"
          >
            Remover foto
          </button>
          <button
            type="button"
            v-if="tipo == 'Copiando'"
            class="btn btn-info"
            @click.prevent="$refs.imagem.click()"
          >
            Alterar foto
          </button>
        </div>
        <div class="col-sm-12 form-group">
            <h4 class="mb-3">Resumo</h4>
            <textarea  class="form-control" v-model="contentEdit.resumo" ></textarea>
        </div>



       <div class="col-sm-12">
            <h4 class="mb-3">Conteúdo</h4>
            <vue-editor :editor-toolbar="customToolbar" v-model="contentEdit.conteudo" />
           <button type="button" class="btn btn-primary mb-3 mt-2" @click.prevent="contentEdit.conteudo =''">Limpar</button>
        </div>       


        <div class="col-sm-12">
          <hr />
        </div>
        <div class="col-3 form-group"  >
          <small>Alterado em:</small>
          <small v-if="contentEdit.tsAlteracao">
             <b>{{formatData(contentEdit.tsAlteracao)}}</b>
          </small>
        </div>
        <div class="col-6 ml-auto text-right">
          <button
            type="button"
            name="cancelar"
            class="btn btn-danger btn-md"
            @click="fnCancela()"
          >Cancelar</button>
          <button
           type="submit"
            name="feedback-form-submit"
            class="btn btn-success ml-3"
          >Gravar</button>
        </div>
      </div>
    </form>
    <div>{{temErro}}</div>
  </div>
</template>
<script>
import { urlApi } from "../../global/utils";

import Tbheader from "../_include/_headerTabelas";
import { getData,getSuccess,getError} from "../../global/utils";
import { VueEditor } from "vue2-editor";
export default {
  props: ["id"],
  data() {
    return {
      novo: true,
      tipo: "",
      icone: "",
    carregado: true,
      carregadoIm: false,
    suporteAtivo: true,
      success: false,
      error:null,
      contentEdit: {
        titulo:'',
        ativo: false,
        autoespecialistas: false,
        esinistros: false,
        gape: false,
        eoficinas: false,
      },      
      customToolbar: [
      ["bold", "italic", "underline"],
      [{ list: "ordered" }, { list: "bullet" }],
      ["blockquote"],
      ["clean"]
    ]

    };
  },
  components: { Tbheader,VueEditor  },
  methods: {
       OnFileSelected(event) {
      if (event.target.id == "imagem") {
        this.contentEdit.imagem = URL.createObjectURL(event.target.files[0]);
        this.imagem = event.target.files[0];
        this.carregado = true;
        this.carregadoIm = true;
      }
    },
    fnRemoveFoto(tipo, i) {
      var filename = "";
      if (i == 1) {
        filename = this.contentEdit.imagem
          .split("/")
          .pop()
          .split("#")[0]
          .split("?")[0];
        this.contentEdit.imagem = null;
      }
      this.$http
        .delete(
          "imageupload/delete" +
            filename 
        )
        .then((res) => {
          console.log(res);
        });
    },
    GetFilename(url) {
      if (url) {
        var m = url.toString().match(/.*\/(.+?)\./);
        if (m && m.length > 1) {
          return m[1];
        }
      }
      return "";
    },
    OnUpload() {
      let fd = new FormData();
      if (this.imagem.name != undefined) {
        fd.append("files", this.imagem, this.imagem.name);
      }

      this.$http
        .post("imageupload/blog", fd)
        .then(() => {
          this.carregado = true;
        });
    },
    fnLimpa(){
      this.contentEdit.titulo = ''
      this.contentEdit.ativo = ''
    },
    fnLimpaConteudo(classe){
      var element = document.getElementsByClassName(classe);
      element[0].innerHTML = "";
    },
    fnicone() {
      this.icone = this.novo ? "icon-line2-plus" : "icon-line-edit";
    },
    fnAtiva() {
          this.contentEdit.ativo = !this.contentEdit.ativo
    },
    fnCancela(){
        this.$router.push({path: "/paineldegerenciamento/blog"})
    },
    async formSubmit(e) {
        e.preventDefault();
        const metodo = this.$route.params.id ? 'put' : 'post';
        this.contentEdit.tsAlteracao = this.$route.params.id ? this.$moment().format() : null;
        const completaUrl = this.$route.params.id ? "/" + this.$route.params.id : '';
        const imgUrl =
        urlApi + "Upload/blog/";
        var chamaUpload = false;
        if (this.carregadoIm) {
            chamaUpload = true;
            this.contentEdit.imagem = imgUrl + this.imagem.name;
        }
       let data = await this.$http[metodo]("/blog" + completaUrl,this.contentEdit)
        .then(() =>{
            if (chamaUpload) {
                this.OnUpload();
            }
            getSuccess();
            this.fnLimpa();
            this.fnCancela();
        })
       .catch(e => {
        return  e
        }); 
        this.error = data
        

    },
    fnGetError(e){
      getError(e)
    },
    fnIsEdit() {
      if (this.$route.params.id != undefined && this.$route.params.id != "") {
        this.tipo = "Editando";
        this.novo = false;
        this.fnCarregaItems(this.$route.params.id)
      } else {
        this.tipo = "Incluindo";
        this.novo = true;
        this.contentEdit.ativo = false
      }
      this.fnicone();
    },
    formatData(value) {
      return this.$moment(String(value)).format("DD/MM/YYYY HH:MM");
    },
    formatData2(value) {
      return this.$moment(String(value)).format("YYYY-MM-DD");
    },
    async fnCarregaItems(valueId) {
      let data = await getData("/blog/"+valueId);
      this.contentEdit = data[0].content;
      this.contentEdit.data = this.formatData2(data[0].content.data)
      this.$vs.loading.close()
    },   
  },
  created() {
    this.fnIsEdit();
  },
  computed: {
    confere: function(){
      return this.fnIsEdit()
    },
    temErro(){
      if (this.error){
         return this.fnGetError(this.error)
      }else{
        return ''
      }
    }
  },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>

</style>